module.exports = __webpack_public_path__ + "assets/img/img58.7a28e2ee.png";